import { observable } from 'mobx';

export type CountryResponseArgs = {
  id: number;
  foreign_region_id: number | null;
  foreign_region_name: string | null;
  foreign_region_code: string | null;
  name: string;
  formal_name: string;
  en_name: string | null;
  iso_2code: string | null;
  ministry_of_foreign_affairs_id: string | null;
  created_at: string;
  updated_at: string;
};

export type CountryArgs = {
  id: number;
  foreignRegionId: number | null;
  foreignRegionName: string | null;
  foreignRegionCode: string | null;
  name: string;
  formalName: string;
  enName: string | null;
  iso2code: string | null;
  ministryOfForeignAffairsId: string | null;
  createdAt: string;
  updatedAt: string;
};

export const convertCountryResponseToArgs = (response: CountryResponseArgs): CountryArgs => {
  return {
    id: response.id,
    foreignRegionId: response.foreign_region_id,
    foreignRegionName: response.foreign_region_name,
    foreignRegionCode: response.foreign_region_code,
    name: response.name,
    formalName: response.formal_name,
    enName: response.en_name,
    iso2code: response.iso_2code,
    ministryOfForeignAffairsId: response.ministry_of_foreign_affairs_id,
    createdAt: response.created_at,
    updatedAt: response.updated_at
  };
};

export default class Country {
  @observable id: number;
  @observable foreignRegionId: number | null;
  @observable foreignRegionName: string | null;
  @observable foreignRegionCode: string | null;
  @observable name: string;
  @observable formalName: string;
  @observable enName: string | null;
  @observable iso2code: string | null;
  @observable ministryOfForeignAffairsId: string | null;
  @observable createdAt: string;
  @observable updatedAt: string;

  constructor(args: CountryArgs) {
    this.id = args.id;
    this.foreignRegionId = args.foreignRegionId;
    this.foreignRegionName = args.foreignRegionName;
    this.foreignRegionCode = args.foreignRegionCode;
    this.name = args.name;
    this.formalName = args.formalName;
    this.enName = args.enName;
    this.iso2code = args.iso2code;
    this.ministryOfForeignAffairsId = args.ministryOfForeignAffairsId;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
  }

  get submitParams() {
    return {
      foreign_region_id: this.foreignRegionId,
      foreign_region_code: this.foreignRegionCode,
      name: this.name,
      formal_name: this.formalName,
      en_name: this.enName,
      iso_2code: this.iso2code,
      ministry_of_foreign_affairs_id: this.ministryOfForeignAffairsId
    };
  }

  static createEmpty(): Country {
    return new Country({
      id: 0,
      foreignRegionId: null,
      foreignRegionName: null,
      foreignRegionCode: null,
      name: '',
      formalName: '',
      enName: null,
      iso2code: null,
      ministryOfForeignAffairsId: null,
      createdAt: '',
      updatedAt: ''
    });
  }
}
